<button type="button" class="btn btn-icon-start text-nowrap" [ngClass]="class" (click)="toggle()">
  <em class="icon">filter_list</em> {{'common-buttons.advanced-filters'|translate}}
</button>
